module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-open_new-17253578.svg";